import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { useQuery } from '@apollo/client';
import { REVOKE_ACCESS_TOKEN_QUERY } from 'Graph/UserGraph';
import { useAuth } from 'Hooks/useAuth';
import { useApolloClient } from '@apollo/client';
import SignOutRedirect from 'Components/empty/Redirect';
import Storage from 'src/utils/storage/storage';

const StyledContainer = styled(Container)`
  max-width: 600px;
  margin-top: 150px;
`;

const StyledBox = styled(Box)`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
`;

const StyledTypography = styled(Typography)`
  color: ${({ theme }) => theme.palette.primary.contrastText};
  font-weight: bold;
`;

// TODO: clean code after testing
const LogoutRedirect = () => {
  // // const { logout } = useAuth();

  // const client = useApolloClient();

  // let token = localStorage.getItem('access');

  // const revokeToken = useQuery(REVOKE_ACCESS_TOKEN_QUERY, {
  //   context: { clientName: 'openHttpLink' },
  //   variables: {
  //     token: token
  //   },
  //   onCompleted: (data) => {
  //     console.log(data, 'this is logout response');
  //     client.cache.reset();
  //     Storage.removeTokens();
  //     logout();
  //   }
  // });

  return (
    <>
      <Helmet>
        <title>Signing out</title>
      </Helmet>
      {/* <StyledContainer maxWidth="md">
        <StyledBox>
          {
            revokeToken.loading
              ? <SignOutRedirect message={"Logging you out. See you soon."} />
              :
              <StyledTypography
                align="center"
                variant="h1"
              >
                Logging you out ...
              </StyledTypography>
          }
        </StyledBox>
      </StyledContainer> */}
    </>
  );
};

export default LogoutRedirect;
